module.exports = __webpack_public_path__ + "img/link10.ffb26695.png";